import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { StaffFacade } from '@galabid/gb-dashboard/staff/data-access'
import * as StaffActions from 'libs/gb-dashboard/staff/data-access/src/lib/+state/staff.actions'
import { TutorialVideosFacade } from 'gb-dashboard/staff/data-access-tutorial-videos'
import * as TutorialVideosActions from 'libs/gb-dashboard/staff/data-access-tutorial-videos/src/lib/+state/tutorial-videos.actions'
import { map, Observable, of } from 'rxjs'
import { ColumnTypeEnum, GbTableColumn } from '@galabid/gb-dashboard/shared/feature'
import { IconLibrary } from 'libs/gb-dashboard/shared/ui/src/lib/gb-icon/gb-icon-library.models'

@Component({
  selector: 'gb-setup-tutorial-videos',
  templateUrl: './gb-setup-tutorial-videos.component.html',
  styleUrls: ['./gb-setup-tutorial-videos.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbSetupTutorialVideosComponent implements OnInit {
  allTutorialVideosWithActions$ = this.tutorialVideosFacade.allTutorialVideos$.pipe(
    map((tutorialVideos) =>
      tutorialVideos.map((tutorialVideo) => ({
        ...tutorialVideo,
        actions: [
          {
            name: 'EDIT',
            icon: 'edit',
            iconLibrary: IconLibrary.material,
            method: () => {
              this.tutorialVideosFacade.dispatch(
                TutorialVideosActions.selectTutorialVideo({ uuid: tutorialVideo.uuid }),
              )
              this.tutorialVideosFacade.dispatch(TutorialVideosActions.openEditTutorialVideoDialog())
            },
          },
          {
            name: 'DELETE',
            icon: 'trash',
            method: () =>
              this.tutorialVideosFacade.dispatch(
                TutorialVideosActions.deleteTutorialVideo({ uuid: tutorialVideo.uuid }),
              ),
          },
        ],
      })),
    ),
  )
  loaded$ = this.tutorialVideosFacade.loaded$

  displayedColumns$: Observable<GbTableColumn[]> = of([
    {
      columnKey: 'target',
      columnLabel: 'STAFF.TUTORIAL_VIDEOS.DASHBOARD_PAGE',
      columnType: ColumnTypeEnum.Label,
    },
    {
      columnKey: 'title',
      columnLabel: 'STAFF.TUTORIAL_VIDEOS.TITLE',
      columnType: ColumnTypeEnum.Label,
    },
    {
      columnKey: 'video_url',
      columnLabel: 'STAFF.TUTORIAL_VIDEOS.VIDEO_URL',
      columnType: ColumnTypeEnum.Label,
    },
    {
      columnKey: 'actions',
      columnLabel: 'ACTIONS',
      columnType: ColumnTypeEnum.Actions,
    },
  ])

  constructor(private tutorialVideosFacade: TutorialVideosFacade) {}

  ngOnInit() {
    this.tutorialVideosFacade.dispatch(TutorialVideosActions.loadTutorialVideos())
  }

  openAddTutorialVideoDialog() {
    this.tutorialVideosFacade.dispatch(TutorialVideosActions.selectTutorialVideo({ uuid: undefined }))
    this.tutorialVideosFacade.dispatch(TutorialVideosActions.openEditTutorialVideoDialog())
  }
}
